/**
 * @generated SignedSource<<4ce8ac842490f82e59f8a233d44e27fa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type storyPointsGroupHeader_issueTableGrouping$data = {
  readonly number: number | null | undefined;
  readonly " $fragmentType": "storyPointsGroupHeader_issueTableGrouping";
};
export type storyPointsGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: storyPointsGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyPointsGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "storyPointsGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraJqlNumberFieldValue"
};

(node as any).hash = "99ed4a1cc4e5ea4a4b3c5cb98de1c14f";

export default node;
